import axios from 'axios'
import { getApiPrefix } from 'models/location/selectors'

const csrfRegexp = /(^|\s|;)sugarcube_csrf=(\S+)(;|$)/

let bearerToken = null
let bearerTokenIsDev = false

export const setBearerToken = (tokens, isDev = false) => {
    const now = Date.now()
    if (tokens.auth && tokens.auth.expirationTime < now) {
        bearerToken = tokens.auth.value
    }
    // DISABLED UNTIL WE SUPPORT GUEST TOKENS IN BACKEND.
    // else if (tokens.guest && tokens.guest.expirationTime < now) {
    //     bearerToken = tokens.guest.value
    // }
    else {
        bearerToken = null
    }
    bearerTokenIsDev = isDev
}

export const getCSRFToken = (cookie = document.cookie) => {
    const match = cookie.match(csrfRegexp)
    return match && match[2]
}

export const fetchWrapper = (url, config = {}) => {
    const completeUrl = `${getApiPrefix()}${url}`
    const updatedConfig = {
        headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
        },
        url: completeUrl,
        ...config,
    }
    if (config.method !== 'GET' && config.method !== 'HEAD') {
        const token = getCSRFToken()
        if (token) {
            updatedConfig.headers['X-CSRFToken'] = token
        }
    }
    if (bearerToken) {
        updatedConfig.headers.Authorization = `Bearer ${bearerToken}`
    }
    if (bearerTokenIsDev) {
        updatedConfig.headers['X-Geomagical-Dev-Auth'] = '1'
    }
    return axios(updatedConfig)
}

export default fetchWrapper
